<div fxLayout="column" fxFlex="0 0 100%">
    <app-table-filter-expansion-panel
        [ngClass]="{ 'hide-paginator': totalOccasionCount$.value < 10 }"
        class="task-expansion"
        #filterExpansion
        [hasTopBorder]="true"
        [expanded]="false"
    >
        <ng-container *ngTemplateOutlet="tableFilters"></ng-container>
    </app-table-filter-expansion-panel>
    <mat-table
        #table
        [dataSource]="dataSource"
        [class.mobileView]="isMobile"
        multiTemplateDataRows
        [ngClass]="{ 'user-table': !user.isAdmin() }"
    >
        <ng-container matColumnDef="enrollment_date">
            <mat-header-cell *matHeaderCellDef>
                <span i18n="@@enrollment_period">Enrollment Period</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let occasion">
                <div class="occasion-period-wrapper" *ngIf="!isMobile" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span *ngIf="!occasion.application_end_date && occasion.application_start_date" i18n>From</span>
                    <span
                        class="capitalize"
                        [matTooltip]="occasion.application_start_date | kdDateFormat : 'YYYY-MM-DD HH:mm'"
                        *ngIf="occasion.application_start_date"
                        >{{ occasion.application_start_date | kdDateFormat : 'MMM D' }}</span
                    >
                    <span *ngIf="occasion.application_end_date" i18n>to</span>
                    <span
                        class="capitalize"
                        [matTooltip]="occasion.application_end_date | kdDateFormat : 'YYYY-MM-DD HH:mm'"
                        *ngIf="occasion.application_end_date"
                        >{{ occasion.application_end_date | kdDateFormat : 'MMM D' }}</span
                    >
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="occasion_date">
            <mat-header-cell *matHeaderCellDef>
                <span i18n="@@occasion_period">Occasion Period</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let occasion">
                <div class="occasion-period-wrapper" *ngIf="!isMobile" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span *ngIf="!occasion.end_date && occasion.start_date" i18n>From</span>
                    <span
                        class="capitalize"
                        [matTooltip]="occasion.start_date | kdDateFormat : 'YYYY-MM-DD HH:mm'"
                        *ngIf="occasion.start_date"
                        >{{ occasion.start_date | kdDateFormat : 'MMM D' }}</span
                    >
                    <span *ngIf="occasion.end_date" i18n>to</span>
                    <span
                        class="capitalize"
                        [matTooltip]="occasion.end_date | kdDateFormat : 'YYYY-MM-DD HH:mm'"
                        *ngIf="occasion.end_date"
                        >{{ occasion.end_date | kdDateFormat : 'MMM D' }}</span
                    >
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="enrollment">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
                    <mat-icon class="header-icon">app_registration</mat-icon>
                    <span i18n="@@enrollment">Enrollment</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let occasion">
                <span class="circles-status approved-users" *ngIf="!isMobile">{{ occasion.enrollment_count }}</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="approved">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
                    <mat-icon class="header-icon">check_circle</mat-icon>
                    <span i18n="@@approved">Approved</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let occasion">
                <ng-container *ngIf="!isMobile">
                    <span class="circles-status registered-users">
                        <span>{{ occasion.approved_count }}</span>

                        <span *ngIf="!!occasion.total_seats">/{{ occasion.total_seats }}</span>
                    </span>
                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="dismissed">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
                    <mat-icon class="header-icon">cancel</mat-icon>
                    <span i18n="@@dismissed">Dismissed</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let occasion">
                <span class="circles-status rejected-users" *ngIf="!isMobile">{{
                    occasion.rejected_count + occasion.waiting_count
                }}</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="pending">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
                    <mat-icon class="header-icon">pending_actions</mat-icon>
                    <span i18n="@@pending">Pending</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let occasion">
                <span
                    [ngClass]="{ 'no-pending': !occasion.pending_count }"
                    class="circles-status waiting-users"
                    *ngIf="!isMobile"
                    >{{ occasion.pending_count }}</span
                >
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="enrollment_count">
            <mat-header-cell *matHeaderCellDef>
                <span i18n="@@enrollments_count">Enrollments Count</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let occasion">
                <div class="enrollment-count-wrapper" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px">
                    <ng-container *ngIf="!occasion.total_seats">
                        <mat-icon matTooltip="Unlimited Seats" i18n-matTooltip="@@unlimitedSeats" class="dark-blue"
                            >all_inclusive</mat-icon
                        >
                    </ng-container>
                    <ng-container *ngIf="!!occasion.total_seats">
                        <span class="total">{{ occasion.enrollment_count }} </span>
                        <div>/</div>
                        <span class="total_seats">{{ occasion.total_seats }} </span>
                    </ng-container>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let occasion" [attr.colspan]="columns.length">
                <div
                    class="example-element-detail"
                    [@detailExpand]="occasion.id == expandedElement ? 'expanded' : 'collapsed'"
                >
                    <app-instructor-enrollments-users-listing
                        *ngIf="occasion.id == expandedElement"
                        [authUser]="user"
                        [occasion]="occasion"
                        [tableFilterItems]="[
                            { property: 'eager', items: ['activations'] },
                            { property: 'enrollment_occasion_date', items: [occasion.id] }
                        ]"
                        [resource]="resource"
                        (onUpdateStatus)="onUpdateStatus.emit()"
                        class="expansion-context"
                    ></app-instructor-enrollments-users-listing>
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="tools">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let occasion" (click)="$event.stopPropagation()">
                <div
                    matTooltip="Add enrollment"
                    i18n-matTooltip
                    (click)="$event.stopPropagation(); addEnrollment(occasion)"
                    class="add-enrollment-wrapper add-enrollment-wrapper-icon"
                >
                    <mat-icon>person_add</mat-icon>
                </div>
                <ng-container *ngIf="showAUContext">
                    <div
                        *ngIf="
                            resourcePlayabilityService.playResource(resource, occasion) | async as playableResourceCheck
                        "
                        [ngStyle]="{
                            'background-color': $any(playableResourceCheck)?.bg,
                            color: $any(playableResourceCheck)?.fg,
                            border: $any(playableResourceCheck)?.border
                        }"
                        mat-raised-button
                        (click)="$event.stopPropagation(); onEnrollMyself.emit({ occasion, resource, playableResourceCheck })"
                        class="add-enrollment-wrapper me"
                    >
                        <mat-icon>{{ $any(playableResourceCheck)?.icon }}</mat-icon>
                        <span>{{ $any(playableResourceCheck)?.label }}</span>
                    </div>
                </ng-container>
                <button
                    *ngIf="occasion.enrollment_count"
                    (click)="
                        $event.stopPropagation(); expandedElement = expandedElement === occasion.id ? null : occasion.id
                    "
                    class="view-users-btn"
                    matTooltip="View users"
                    mat-icon-button
                    i18n-matTooltip="@@viewUsers"
                >
                    <mat-icon>{{ expandedElement === occasion.id ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
                <button *ngIf="!occasion.enrollment_count" (click)="$event.stopPropagation()" mat-icon-button>
                    <mat-icon></mat-icon>
                </button>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row
            [ngClass]="!occasion.loading ? 'link' : 'disableIt'"
            [class.example-expanded-row]="expandedElement === occasion.id"
            [class.last-table-row]="isLastRow(occasion)"
            (click)="
                occasion.enrollment_count && (expandedElement = expandedElement === occasion.id ? null : occasion.id)
            "
            *matRowDef="let occasion; columns: columns"
        ></mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></mat-row>
    </mat-table>
    <mat-paginator
        [ngClass]="{ 'hide-paginator': totalOccasionCount$.value < 10 }"
        [pageSize]="25"
        [pageSizeOptions]="[25, 50, 100]"
    >
    </mat-paginator>
</div>
<ng-template #loadingTemp>
    <div fxFlex="0 0 100%" fxLayout="row" fxLayoutAlign="center" class="spinner-container">
        <app-kd-logo-loading sizeee="small"></app-kd-logo-loading>
    </div>
</ng-template>
<ng-template #tableFilters>
    <app-table-filter class="w-100" [filtersTogglesInOnBtn]="true" [inGlobalFilter]="true" color="accent" #filter>
        <app-table-search
            toggleBtnLabel="All"
            i18n-toggleBtnLabel
            [inGlobalFilter]="true"
            class="align-space"
            searchFilterRef
        ></app-table-search>
        <app-select-filter
            [inGlobalFilter]="true"
            class="filter-space"
            label="Approval"
            i18n-label
            [property]="GlobalFilterProperty.REVIEW_STATUS"
            [options]="approvalStatusOptions"
            resApprovalStatusRef
        ></app-select-filter>
        <app-table-date-filter [inGlobalFilter]="true" color="accent" dateFilterRef></app-table-date-filter>
    </app-table-filter>
</ng-template>
